import { render, staticRenderFns } from "./AccreditedTestModal.vue?vue&type=template&id=f08379dc"
import script from "./AccreditedTestModal.vue?vue&type=script&lang=js"
export * from "./AccreditedTestModal.vue?vue&type=script&lang=js"
import style0 from "./AccreditedTestModal.vue?vue&type=style&index=0&id=f08379dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports